export const InputmaskGlossary = {
    postIndex: '9{6}',                              // Почтовый индекс из 6-и цифр, например 636900
    certificateNumber: '[9{4}-][9{1,}[-]9{1,}]',    // Номер удостоверения. 4 цифры, тире, цифры, одно тире и потом снова числа
    legalInn: '9{10}',                              // ИНН 10 цифр.
    personInn: '9{12}',                             // ИНН физ лица 12 цифр.
    kpp: '9{9}',                                    // КПП 9 цифр
    okpo: '9{8}',                                   // ОКПО 8 цифр
    ogrn: '9{13}',                                  // ОГРН 13 цифр
    operating_account: '9{20}',                     // Расчетный счет, 20 символов
    correspondent_account: '9{20}',                 // Корреспондентский счет, 20 символов
    rcbic: '9{9}',                                  // БИК банка, 9 символов
    customPhone: '[+][✆{1,}]',                      // Произвольный номер телефона
    mobilePhone: '+7 (999) 999-99-99',              // Мобильный телефон,
    numeric: '[9{1,}]',                             // Числовое значение любой длины
    float: '[9{1,}([.]|[,])9{1,}]',                 // Числовое значение любой длины с одной точкой или запятой в центре
    count: '[*{1,}]',                               // Количество. Маска задается в коде, тут дефолтное значение, чтобы показать ее наличие
    fiveDigitsNumber: '[9{1,5}]',                   // Пяти-разрядное целое число
};
